/*
 * @Author: Q in
 * @Date: 2025-07-21 11:45:39
 * @LastEditors: Q in 
 * @LastEditTime: 2026-07-24 15:13:07
 * @FilePath: /yihao_web/src/utils/request.js
 * @Description: 请求封装
 */
import configInfo from '@/utils/config.js';
import axios from 'axios';
import Router from '@/router/index';
import Store from '@/store/index';
import { MessageBox } from 'element-ui';
import { Encrypt, Decrypt } from '@/utils/aes';

// 基本配置
const instance = axios.create({
	baseURL: configInfo.baseApiDomain, // 根据实际情况修改API地址
	timeout: 10000 // 设置超时时间，单位为ms
});

// 请求拦截器
instance.interceptors.request.use(
	(config) => {
        const token = Store.getters.getUserInfo?.token ? Store.getters.getUserInfo?.token : '';
		if (token) {
			config.headers['Authorization'] = token;
			config.headers['token'] = token;
		}
        if (config.data?.send_data && process.env.NODE_ENV == 'development') {
            const send_data = JSON.parse(Decrypt(config.data.send_data));
            for (let key in send_data) {
                config.data[key] = send_data[key];
            }
        }
		return config;
	},
	(error) => {
		// console.log(error);
		return Promise.reject(error);
	}
);

// 响应拦截器
instance.interceptors.response.use(
	(response) => {
		let { data, status } = response;
		if (status === 200) {
			return data;
		} else {
			// 如果状态码不是200，可以抛出一个错误，在调用处进行处理
			throw new Error(`请求失败，状态码：${status}`);
		}
	},
	(error) => {
		// 在这里处理响应错误，比如网络错误、服务器返回错误等
		if (error.response) {
			// 服务器返回了错误响应，处理错误信息
			let { status, data } = error.response;
			switch (status) {
				case 401:
					MessageBox.confirm('当前登录已过期，请重新登录', '提示', {
						confirmButtonText: '确定',
						showClose: false,
						showCancelButton: false,
						closeOnPressEscape: false,
						closeOnClickModal: false,
						type: 'warning'
					}).then(() => {
						Store.commit('clearLoginInfo');
					});
					break;
				default:
					console.error(`服务器返回错误，状态码：${status}，错误信息：${data}`);
			}
		} else if (error.request) {
			// 请求已经发出，但没有收到响应，可能是网络问题
			console.error('网络问题，请求未收到响应');
		} else {
			// 其他未知错误
			console.error('其他未知错误：', error);
		}

		return Promise.reject(error);
	}
);

export default instance;
